import React from 'react'
import { Form } from 'react-bootstrap'
import { onSubmitText } from '../../../constantes/onSubmitText'
import RequieredInputs from '../../common/RequiredInputs'
import _ from 'lodash'

const NewPresentationForm = ({
    hospitals,
    hospitalsContacts,
    hospitalSpeciality,
    handleChange,
    inputs,
    handleSubmitCreateNewPresentation,
    isDisable,
}) => {
    
    hospitals = _.orderBy(hospitals, ['nombre'],['asc'])
    hospitalsContacts = _.orderBy(hospitalsContacts, ['nombre'],['asc'])
    return (
        <>
            <Form className="products__form">
                <div>
                    <Form.Group size="lg" controlId="titlePresentation-name">
                        <Form.Label className="form__labels">Título de la presentación <RequieredInputs/> </Form.Label>
                        <Form.Control className="user-input titlePresentation"
                            type="text"
                            name="nombre"
                            value={inputs.nombre}
                            onChange={handleChange}
                            placeholder="Título de la presentación"
                        />
                    </Form.Group>
                    <div className="row">
                        <Form.Group className="col-5" size="lg" controlId="hospital-name">
                            <Form.Label className="form__labels">Contacto <RequieredInputs/></Form.Label>
                            <Form.Control
                                as="select"
                                className="user-input "
                                type="text"
                                name="id_Contacto"
                                value={inputs.id_Contacto}
                                onChange={handleChange }
                            >
                                <option hidden> Elegir Contacto </option>
                                {
                                    hospitalsContacts.length > 0 ? hospitalsContacts.map((hospitalContact, i) => 
                                        <option key={i} value={hospitalContact.id_Contacto}> {hospitalContact.nombre} </option>
                                    ) : null
                                }
                            </Form.Control>
                        </Form.Group>
                        <Form.Group className="col-7" size="lg" controlId="doctor-name">
                            <Form.Label className="form__labels">Hospital / Centro <RequieredInputs/></Form.Label>
                            <Form.Control
                                as="select"
                                className="user-input "
                                type="text"
                                name="id_Hospital"
                                value={inputs.id_Hospital}
                                onChange={handleChange}
                            >
                                <option hidden> Elegir Hospital </option>
                                    {
                                        hospitals ? hospitals.map((hospital, i) =>
                                            <option key={i} value={hospital.id_Hospital}> {hospital.nombre} </option>
                                        ): null
                                    }
                            </Form.Control>                       
                        </Form.Group> 
                    </div>
                    <Form.Group size="lg" controlId="hospitalSpeciality">
                        <Form.Label className="form__labels">Especialidad</Form.Label>
                        <Form.Control className="user-input readOnly"
                            type="text"
                            name="especialidad"
                            value={hospitalSpeciality}
                            placeholder="Especialidad Hospital"
                            readOnly
                            disabled
                        />                   
                    </Form.Group> 
                </div>
                <button className="btn"
                    disabled={isDisable}
                    onClick={handleSubmitCreateNewPresentation}
                >
                    {onSubmitText.Crear}
                </button>
            </Form> 
        </>
    )
}

export default NewPresentationForm